import * as React from 'react'
import { Box, Stack, Avatar, IconButton } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import KebabMenu from '../../dataGrid/KebabMenu'
import StatusBtn from '../status/StatusBtn'
import TableData from './TableData'

export default function TableDataGrid() {
	const navigate = useNavigate()

	const rows = [
		{
			id: '1',
			task: 'Stabilise feeding pattern',
			assignedTo: 'Hakim Ahmed',
			dueDate: '2025-08-27',
			priority: 'High',
			comments: 'Smooth experience overall, but a few hiccups.',
			status: 'Completed',
			avatar: 'https://static.vecteezy.com/system/resources/previews/020/911/740/non_2x/user-profile-icon-profile-avatar-user-icon-male-icon-face-icon-profile-icon-free-png.png',
		},
		{
			id: '2',
			task: 'Change bedding for all cows',
			assignedTo: 'Hakim Ahmed',
			dueDate: '2025-08-27',
			priority: 'Medium',
			comments: 'SaaS needs improvement; considering other options.',
			status: 'Pending',
			avatar: 'https://static.vecteezy.com/system/resources/previews/020/911/740/non_2x/user-profile-icon-profile-avatar-user-icon-male-icon-face-icon-profile-icon-free-png.png',
		},
		{
			id: '3',
			task: 'Devide milking group for better hierarchy Devide milking group for better hierarchy Devide milking group for better hierarchy',
			assignedTo: 'Hakim Ahmed',
			dueDate: '2025-08-27',
			priority: 'Low',
			comments:
				'Love the features, but occasional glitches are frustrating.',
			status: 'Completed',
			avatar: 'https://static.vecteezy.com/system/resources/previews/020/911/740/non_2x/user-profile-icon-profile-avatar-user-icon-male-icon-face-icon-profile-icon-free-png.png',
		},
		{
			id: '4',
			task: 'Devide milking group for better hierarchy',
			assignedTo: 'Hakim Ahmed',
			dueDate: '2025-08-27',
			priority: 'High',
			comments:
				'Love the features, but occasional glitches are frustrating.',
			status: 'In Progress',
			avatar: 'https://static.vecteezy.com/system/resources/previews/020/911/740/non_2x/user-profile-icon-profile-avatar-user-icon-male-icon-face-icon-profile-icon-free-png.png',
		},
	]
	const columns = [
		{
			field: 'task',
			headerName: 'Task',
			flex: 1.6,
			minWidth: 220,
			sortable: true,
			renderCell: (params) => {
				return (
					<Box component="span" sx={{ fontWeight: 600 }}>
						{params.row.task}
					</Box>
				)
			},
		},
		{
			field: 'assignedTo',
			headerName: 'Assigned to',
			flex: 1.6,
			minWidth: 220,
			sortable: true,
			renderCell: (params) => {
				const { avatar, assignedTo } = params.row
				return (
					<Stack direction="row" spacing={1.5} alignItems="center">
						<Avatar src={avatar} sx={{ width: 32, height: 32 }} />
						<Box component="span">{assignedTo}</Box>
					</Stack>
				)
			},
		},
		{
			field: 'dueDate',
			headerName: 'Due Date',
			flex: 1,
			minWidth: 140,
		},
		{
			field: 'priority',
			headerName: 'Priority',
			flex: 1,
			minWidth: 100,
			renderCell: (params) => {
				const { priority } = params.row
				return (
					<Stack direction="row" spacing={1.5} alignItems="center">
						<Box component="span" className="priority-icon">
							<img
								src={
									priority === 'High'
										? '/images/high-prio-icon.svg'
										: priority === 'Medium'
											? '/images/med-prio-icon.svg'
											: '/images/low-prio-icon.svg'
								}
								alt="priority.png"
							/>
							{priority}
						</Box>
					</Stack>
				)
			},
		},
		{
			field: 'comments',
			headerName: 'Comments',
			flex: 2,
			minWidth: 200,
		},
		{
			field: 'status',
			headerName: 'Status',
			flex: 1,
			minWidth: 130,
			renderCell: (params) => {
				const status = params.value

				return (
					<StatusBtn
						label={status}
						variant={
							status === 'Completed'
								? 'completed'
								: status === 'Pending'
									? 'pending'
									: status === 'In Progress'
										? 'inprogress'
										: 'default' // Default value in case none of the conditions match
						}
						size="small"
					/>
				)
			},
		},
		{
			field: 'menu',
			headerName: '',
			sortable: false,
			filterable: false,
			width: 64,
			align: 'right',
			renderCell: (params) => (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-end',
						width: '100%',
						height: '100%',
					}}
				>
					<IconButton
						data-cy="kebab"
						size="small"
						onClick={(e) => openMenu(e, params.row)}
						sx={{ p: 0.5 }}
					>
						<img src="/images/more.svg" alt="" />
					</IconButton>
				</Box>
			),
		},
	]

	const [menuAnchor, setMenuAnchor] = React.useState(null)
	const [menuRow, setMenuRow] = React.useState(null)

	const openMenu = (e, row) => {
		e.stopPropagation()
		setMenuAnchor(e.currentTarget)
		setMenuRow(row)
	}

	const closeMenu = () => {
		setMenuAnchor(null)
		setMenuRow(null)
	}

	return (
		<div style={{ gridTemplateColumns: '1fr 1fr' }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					height: 'calc(100vh - 420px)',
					minHeight: 200,
					'@media (max-width: 900px)': {
						height: 'calc(100vh - 390px)',
					},
				}}
			>
				<Box sx={{ flex: 1, minHeight: 0 }}>
					<TableData rows={rows} columns={columns} height="100%" />
				</Box>

				<KebabMenu
					anchorEl={menuAnchor}
					open={Boolean(menuAnchor)}
					onClose={closeMenu}
					items={[
						{
							key: 'Edit',
							label: 'Edit',
							icon: <img src="/images/edit-icon.svg" alt="" />,
							onClick: () => navigate(`/profile/${menuRow?.id}`),
						},
						{
							key: 'delete',
							label: 'Delete',
							icon: <img src="/images/DeleteModal.svg" alt="" />,
							onClick: () => console.log('Delete', menuRow),
							color: 'error.main',
						},
					]}
				/>
			</Box>
		</div>
	)
}
